import { render, staticRenderFns } from "./scope40.vue?vue&type=template&id=3653fdd0&scoped=true"
import script from "./scope40.vue?vue&type=script&lang=js"
export * from "./scope40.vue?vue&type=script&lang=js"
import style0 from "./scope40.vue?vue&type=style&index=0&id=3653fdd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3653fdd0",
  null
  
)

export default component.exports